import { render, staticRenderFns } from "./FormSectionDescription.vue?vue&type=template&id=0fd213ac&scoped=true"
import script from "./FormSectionDescription.vue?vue&type=script&lang=js"
export * from "./FormSectionDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd213ac",
  null
  
)

export default component.exports